export const SET_SEARCHED_PEOPLE = 'setState_SET_SEARCHED_PEOPLE';
export const SET_MY_TEAM = 'setState_SET_MY_TEAM';
export const ADD_SELECTED_PERSON = 'setState_ADD_SELECTED_PERSON';
export const REMOVE_SELECTED_PERSON = 'setState_REMOVE_SELECTED_PERSON';
export const CLEAR_SEARCHED_PEOPLE = 'setState_CLEAR_SEARCHED_PEOPLE';
export const ADD_AWARD_TO_PERSON = 'setState_ADD_AWARD_TO_PERSON';